module.exports = __webpack_public_path__ + "static/media/wave.ad5cfb63.png";